<template>
  <div class="insured-form-container">
    <Panel title="1.ข้อมูลของผู้ขอเอาประกันภัย">
      <div class="customer-inquiry-section row">
        <div class="form-group col-sm-5">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">ประเภทบัตร</span>
            <Dropdown
              class="form-control input-sm"
              :options="identityOptions"
              v-model="customerIdentity.type"
              :selectedValue="customerIdentity.type"
              :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
            />
          </div>
        </div>
        <div class="form-group col-sm-7">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg tx-card-rm">{{ renderIdentityText() }}</span>
            <input
              type="text"
              class="form-control input-sm"
              :class="{
                'bd-red': errors.has('identityNumber') || !verifyCitizen(),
              }"
              :maxlength="customerIdentity.type === 'idCard' ? 13 : ''"
              name="card_id"
              v-model="customerIdentity.number"
              :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
            />
          </div>
        </div>
        <div class="customer-inquiry-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            type="info"
            data-type="amlo-pass"
            @click.native="triggerGetCustomerInquiry"
            :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
          >
            <i class="fa fa-search"></i> ค้นหา
          </Button>
        </div>
      </div>
      <div class="customer-check-amlo-section row">
        <div class="form-insured-name-section clearfix">
          <div class="form-group col-sm-3">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">คำนำหน้าชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.namePrefix"
                disabled
              />
            </div>
          </div>
          <div class="form-group col-sm-4">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.firstname"
                disabled
              />
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.lastname"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="form-insured-dob-section clearfix">
          <div class="form-group col-sm-7">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                วัน/เดือน/ปีเกิด (พ.ศ.)
              </span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.dob"
                disabled
              />
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อายุ</span>
              <span class="h6 m-l m-t-xs text-primary"> {{ customerInformation.age }} ปี </span>
              <span class="h6 m-l m-t-xs text-primary" v-if="customerInformation.ageMonth">
                {{ customerInformation.ageMonth }} เดือน
              </span>
            </div>
          </div>
        </div>
        <div class="form-insured-contact-section clearfix">
          <div class="email-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อีเมล</span>
              <input
                type="text"
                class="form-control input-sm "
                v-model="customerInformation.email"
                disabled
              />
            </div>
          </div>
          <div class="phone-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">โทรศัพท์มือถือ</span>
              <input
                type="text"
                class="form-control input-sm "
                v-model="customerInformation.phone"
                disabled
              />
            </div>
            <div class="warning-text">
              “หากท่านระบุเบอร์โทรศัพท์มือถือไม่ถูกต้อง
              จะไม่สามารถทำการชำระเงินด้วยวิธีการหักผ่านบัญชี ttb ได้”
            </div>
          </div>
        </div>
        <div class="customer-check-amlo-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            :type="!isCheckAmloSuccess ? 'info' : isPassAmlo ? 'primary' : 'danger'"
            data-type="amlo-pass"
            @click.native="verifyAmlo"
            :disabled="disabledForm || checkDisabledCustomerInformationSection()"
          >
            <i
              class="fa"
              :class="{
                'fa-search': !isCheckAmloSuccess,
                'fa-check-circle-o': isCheckAmloSuccess && isPassAmlo,
                'fa-times-circle-o': isCheckAmloSuccess && !isPassAmlo,
              }"
            />
            <span v-if="!isCheckAmloSuccess"> ตรวจสอบ AMLO</span>
            <span v-else>{{ isPassAmlo ? ' ผ่าน AMLO' : ' ไม่ผ่าน AMLO' }}</span>
          </Button>
        </div>
      </div>
      <div class="line line-dashed line-lg" />
      <div class="customer-personal-information-section row">
        <div class="form-insured-personal-section clearfix">
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                ส่วนสูง
              </span>
              <input
                type="tel"
                class="form-control input-sm"
                :class="{ 'bd-red': errors.has('height') }"
                maxlength="3"
                v-model="personalInformation.height"
                :disabled="disabledForm || checkDisabledPersonalInformationSection()"
              />
              <span class="input-group-addon">ซม.</span>
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                น้ำหนัก
              </span>
              <input
                type="tel"
                class="form-control input-sm "
                :class="{ 'bd-red': errors.has('weight') }"
                maxlength="3"
                v-model="personalInformation.weight"
                :disabled="disabledForm || checkDisabledPersonalInformationSection()"
              />
              <span class="input-group-addon">กก.</span>
            </div>
          </div>

          <div class="form-group col-sm-6">
            <div class="input-group" :class="{ 'bd-red': errors.has('gender') }">
              <span class="input-group-addon nobd-nobg">
                เพศ
              </span>
              <div class="col-md-3 col-xs-3">
                <Radio
                  name="gender"
                  label="M"
                  v-model="personalInformation.gender"
                  :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                >
                  ชาย
                </Radio>
              </div>
              <div class="col-md-3 col-xs-3">
                <Radio
                  name="gender"
                  label="F"
                  v-model="personalInformation.gender"
                  :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                >
                  หญิง
                </Radio>
              </div>
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อาชีพ</span>
              <Dropdown
                class="form-control input-sm"
                :class="{ 'bd-red': errors.has('occupation') }"
                :options="occupationOptionsList"
                v-model="personalInformation.occupation"
                :selectedValue="personalInformation.occupation"
                :disabled="disabledForm || checkDisabledPersonalInformationSection()"
              />
            </div>
          </div>
        </div>
        <div class="verify-insured-status-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            :type="!isValidateInformationSuccess ? 'info' : 'primary'"
            data-type="amlo-pass"
            @click.native="checkRiskTviInsurance"
            :disabled="disabledForm || checkDisabledPersonalInformationSection()"
          >
            <span v-if="!isValidateInformationSuccess">
              <i class="fa fa-search"></i> ตรวจสอบการรับประกันภัย
            </span>
            <span v-else>
              ผ่านการรับประกันภัย
            </span>
          </Button>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import moment from 'moment'
import _ from 'lodash'

import Button from '@/components/Button'
import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'
import { DATE_FORMAT, identityNumberText, passportNumberText, validationRule } from '@/lib/global'
import { validateBMI, validateCitizenNumber, validateOccupation } from '@/lib/services'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'InsuredForm',
  props: ['typeInsurance', 'quotationId', 'disabledForm'],
  data() {
    return {
      identityOptions: [
        {
          value: 'idCard',
          description: 'บัตรประจำตัวประชาชน',
        },
        {
          value: 'passport',
          description: 'เลขที่หนังสือเดินทาง',
        },
      ],
      occupationOptionsList: [],
      rules: {
        identityNumber: 'required|numeric|min:13|max:13',
        gender: 'required',
        occupation: 'required',
        height: 'required|numeric',
        weight: 'required|numeric',
      },
      errors: null,
    }
  },
  components: {
    Button,
    Dropdown,
    Panel,
    Radio,
  },
  computed: {
    ...mapGetters(['occupationList']),
    ...mapQuotationFields({
      customerIdentity: 'insuredDetail.data.customerIdentity',
      customerInformation: 'insuredDetail.data.customerInformation',
      personalInformation: 'insuredDetail.data.personalInformation',
      isGetCustomerIdentitySuccess: 'insuredDetail.data.isGetCustomerIdentitySuccess',
      isCheckAmloSuccess: 'insuredDetail.data.isCheckAmloSuccess',
      isPassAmlo: 'insuredDetail.data.isPassAmlo',
      isValidateInformationSuccess: 'insuredDetail.data.isValidateInformationSuccess',
    }),
  },
  watch: {
    occupationList: {
      deep: true,
      handler(dataList) {
        const generateOptionsList = dataList.map(data => ({
          value: data.id,
          description: data.name_th,
        }))
        const occupationList = [
          {
            code: '',
            description: 'กรุณาเลือกอาชีพ',
          },
          ...generateOptionsList,
        ]

        this.occupationOptionsList = occupationList
      },
    },
    'customerIdentity.type'(val) {
      this.customerIdentity.number = null

      const { idCard, passport } = validationRule.customerIdentity

      const isIdCardType = val === 'idCard'
      this.rules.identityNumber = isIdCardType ? idCard : passport

      this.setRule()
    },
    'customerIdentity.number'(val) {
      if (val) {
        this.validator.validate('identityNumber', val)
      }
    },
  },
  mounted() {
    this.getOccupationInformation()
  },
  methods: {
    ...mapActions([
      'getCustomerInquiryInformation',
      'checkCustomerAmlo',
      'checkRiskTvi',
      'createNewQuotation',
      'getOccupationInformation',
    ]),
    renderIdentityText() {
      return this.customerIdentity.type === 'idCard' ? identityNumberText : passportNumberText
    },
    verifyCitizen() {
      const idNumber = this.customerIdentity.number

      if (this.customerIdentity.type === 'idCard' && idNumber) {
        return validateCitizenNumber(idNumber)
      }

      return true
    },
    checkDisabledCustomerIdentitySection() {
      if (this.isGetCustomerIdentitySuccess) {
        return true
      }

      return false
    },
    checkDisabledCustomerInformationSection() {
      if (!this.isGetCustomerIdentitySuccess || this.isCheckAmloSuccess) {
        return true
      }

      return false
    },
    checkDisabledPersonalInformationSection() {
      if (!this.isCheckAmloSuccess || this.isValidateInformationSuccess) {
        return true
      }

      return false
    },
    triggerGetCustomerInquiry() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number

      this.validator
        .validateAll({
          identityNumber: citizenId,
        })
        .then(validationResult => {
          if (validationResult && this.verifyCitizen()) {
            this.getCustomerInquiryInformation({
              field: 'insuredDetail',
              cardType: cardPersonalType === 'idCard' ? 'CI' : 'PP',
              citizenId,
            })
          }
        })
    },
    verifyAmlo() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number

      this.checkCustomerAmlo({
        field: 'insuredDetail',
        cardType: cardPersonalType === 'idCard' ? 'CI' : 'PP',
        citizenId,
      })
    },
    checkRiskTviInsurance() {
      this.validator.validateAll(this.personalInformation).then(validationResult => {
        if (validationResult) {
          const { type, number } = this.customerIdentity
          const { age, ageDay } = this.customerInformation
          const { weight, height, gender, occupation } = this.personalInformation

          const resultValidateBMI = validateBMI(weight, height, age)
          const resultValidateOccupation = validateOccupation(occupation, this.occupationList)
          const resultValidateInsuredAge = this.isAllowInsuredAge(age, ageDay)

          if (resultValidateBMI && resultValidateOccupation && resultValidateInsuredAge) {
            const checkHasQuotationId = () => {
              if (this.quotationId) {
                return { quotationId: this.quotationId }
              }

              return {}
            }

            const requestBody = {
              cardType: type === 'idCard' ? 'CI' : 'PP',
              citizenId: number,
              personalInformation: {
                weight,
                height,
                sex: gender,
                occupationId: occupation,
              },
            }

            const data = {
              ...checkHasQuotationId(),
              requestBody,
            }

            this.checkRiskTvi(data)
          } else {
            this.$swal({
              type: 'error',
              title: 'ขออภัย ข้อมูลของท่านไม่ตรงกับข้อกำหนดและเงื่อนไขของบริษัทประกันภัยไทยวิวัฒน์',
            }).then(() => (this.disabledForm = true))
          }
        }
      })
    },
    isAllowInsuredAge(ageYear, ageDay) {
      if (ageYear > 70) {
        return false
      }

      if (ageYear <= 0 && ageDay < 30) {
        return false
      }

      return true
    },
    clearErrors() {
      this.errors.clear()
    },
    setRule() {
      this.validator = new Validator(this.rules)
      this.$set(this, 'errors', this.validator.errors)
    },
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss">
$black_color: #000000;

.checkbox,
.radio {
  margin-top: 0px !important;
}

.panel {
  &.panel-default {
    > .panel-heading {
      padding: 5px 20px 5px 12px !important;
    }
  }
}

.insured-form-container {
  .insured-form-panel-header {
    color: $black_color;
  }

  .customer-inquiry-section {
    margin-bottom: 32px;
  }

  .customer-check-amlo-section {
    margin-bottom: 24px;

    .form-insured-contact-section {
      .phone-form-group {
        .warning-text {
          color: #eb5757;
          font-size: 12px;
          line-height: 16px;
          margin-top: 8px;
          margin-left: 95px;
        }
      }
    }
  }

  .customer-personal-information-section {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}
</style>
